/** First-load placeholders. ⛔ Never shown over existing data — that is what makes stale look fresh. */

export function SkeletonBar({ className = '' }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded bg-[color:var(--color-line)] ${className}`}
    />
  );
}

export function TicketRowSkeleton() {
  return (
    <div className="border-b border-[color:var(--color-line)] px-3 py-3 sm:px-4">
      <div className="flex items-center gap-3">
        <SkeletonBar className="h-4 w-4 shrink-0" />
        <SkeletonBar className="h-4 w-20 shrink-0" />
        <SkeletonBar className="h-4 flex-1" />
        <SkeletonBar className="hidden h-6 w-28 shrink-0 sm:block" />
      </div>
      <SkeletonBar className="mt-2 ml-7 h-3 w-2/5" />
    </div>
  );
}

export function ListSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div role="status" aria-label="Loading tickets">
      {Array.from({ length: rows }, (_, index) => (
        <TicketRowSkeleton key={index} />
      ))}
    </div>
  );
}

export function Spinner({ label }: { label: string }) {
  return (
    <span
      role="status"
      aria-label={label}
      className="inline-block size-3.5 animate-spin rounded-full border-2 border-current border-t-transparent align-[-2px] opacity-70"
    />
  );
}
